import React, { useEffect } from 'react';
import { useSession } from '@/lib/session';
import { useApi } from '@/lib/hooks';
import { Icon } from '@/components/ui/Icon';
import styles from './ChildSwitcher.module.css';

export function ChildSwitcher({ fullWidth = false }) {
  const { role, selectedChild, setSelectedChild } = useSession();
  const { data: meData } = useApi(role === 'parent' ? '/auth/me' : null);

  const children = meData?.children || meData?.user?.children || [];

  useEffect(() => {
    if (role !== 'parent' || children.length === 0) return;

    // If no child is selected yet or selected child is no longer valid, select the first
    if (!selectedChild || !children.some((c) => c.student_id === selectedChild.student_id)) {
      setSelectedChild(children[0]);
    }
  }, [role, children, selectedChild, setSelectedChild]);

  if (role !== 'parent' || children.length === 0) {
    return null;
  }

  if (children.length === 1) {
    const c = children[0];
    const cName = c.class_name ? c.class_name.replace(/^Class\s*/i, '') : '6';
    return (
      <div className={`${styles.switcherContainer} ${fullWidth ? styles.fullWidth : ''}`}>
        <div className={styles.singleChildBadge}>
          <Icon name="user" size={14} />
          <span>{c.name} ({cName}-{c.section})</span>
        </div>
      </div>
    );
  }

  const currentStudentId = selectedChild?.student_id || children[0].student_id;

  const handleChange = (e) => {
    const sId = parseInt(e.target.value, 10);
    const chosen = children.find((c) => c.student_id === sId);
    if (chosen) {
      setSelectedChild(chosen);
    }
  };

  return (
    <div className={`${styles.switcherContainer} ${fullWidth ? styles.fullWidth : ''}`}>
      <div className={styles.childSelectWrapper}>
        <select
          value={currentStudentId}
          onChange={handleChange}
          className={styles.childSelect}
          aria-label="Select student ward"
        >
          {children.map((c) => {
            const cName = c.class_name ? c.class_name.replace(/^Class\s*/i, '') : '6';
            return (
              <option key={c.student_id} value={c.student_id}>
                {c.name} ({cName}-{c.section})
              </option>
            );
          })}
        </select>
        <Icon name="chevronDown" size={14} className={styles.arrowIcon} />
      </div>
    </div>
  );
}
